import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  labelId: string;
  children: ReactNode;
}

export default function ConfigurationSummaryRow({ labelId, children }: Props) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-slate-600">
        <FormattedMessage id={labelId} />
      </span>
      <span className="text-sm text-slate-900">
        {children}
      </span>
    </div>
  );
}
